module.exports = __webpack_public_path__ + "img/7bf29cd26aaa7004a5aa7519f17f1462.svg";